import React from 'react';
import Alert from './Alert';
import { ALERT_TYPES } from './constants';

export default function AlertSuccess(props) {
  return <Alert {...props} type={ALERT_TYPES.SUCCESS} />;
}
